// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__mJgNg","infoBtn":"quickbooks_infoBtn__2yPQ6","formBox":"quickbooks_formBox__2txQh","formFooter":"quickbooks_formFooter__2LCix"};